// extracted by mini-css-extract-plugin
module.exports = {"styledTableCell":"PoHB448A"};